import * as React from 'react';
import MuiSkeleton, { SkeletonProps as OriginalSkeletonProps } from '@material-ui/lab/Skeleton';
import { randomNumber, randomNumberWithPercent } from '../../utils/randomNumber';
import { Uds } from '../../types';
import { useMemo, useState } from 'react';

export type SkeletonProps = Uds<
  Omit<OriginalSkeletonProps, 'css'> & {
    /*! by default [30,60] */
    randomWidthInPercentage?: boolean | [number, number];
    randomWidthAsNumber?: boolean | [number, number]; // by default [30,60]
    inline?: boolean;
  }
>;

export const Skeleton: React.FC<React.PropsWithChildren<SkeletonProps>> = ({
  randomWidthInPercentage: randomWidthInPercentageProp,
  randomWidthAsNumber: randomWidthAsNumberProps,
  width,
  inline,
  style,
  dataTest,
  ...rest
}) => {
  const [randomWidthInPercentage] = useState(randomWidthInPercentageProp);
  const [randomWidthAsNumber] = useState(randomWidthAsNumberProps);

  const targetWidth = useMemo(() => {
    if (randomWidthInPercentage) {
      return typeof randomWidthInPercentage === 'boolean'
        ? randomNumberWithPercent(30, 60)
        : randomNumberWithPercent(randomWidthInPercentage[0], randomWidthInPercentage[1]);
    }
    if (randomWidthAsNumber) {
      return typeof randomWidthAsNumber === 'boolean'
        ? randomNumber(30, 60)
        : randomNumber(randomWidthAsNumber[0], randomWidthAsNumber[1]);
    }
    return width;
  }, [randomWidthAsNumber, randomWidthInPercentage, width]);

  return (
    <MuiSkeleton
      data-test={dataTest}
      {...{
        ...rest,
        width: targetWidth,
        style: {
          ...style,
          display: inline ? 'inline-block' : undefined
        }
      }}
    />
  );
};
